<template>
  <div class="tab-label">
    <div class="label">
      {{ label }}
      <span
        v-if="messagesAmount > 0 && messagesAmount < 100"
        class="badge"
      >{{ messagesAmount }}</span>
      <span
        v-else-if="messagesAmount >= 100"
        class="badge__99-plus"
      >+99</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    label: String,
    showingTab: Boolean,
    messagesAmount: Number
  }
}
</script>

<style lang="scss">
.tab-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 30px 15px 30px;
  border-bottom-style: solid;
  border-bottom-width: 7px;
  width: 50%;
  border-bottom-color: #f4f4f4;
  color: #9c9c9c;
  cursor: pointer;

  .label {
    opacity: 1;
    margin: auto;
    width: 100%;
    font-size: 12px;
    font-weight: 900;
    line-height: 1.17;
    letter-spacing: 0.5px;
    text-align: center;
    cursor: pointer;
  }

  .badge {
    background-color: #ea0049;
    border-radius: 2px;
    font-size: 10px;
    margin-left: 5px;
    width: 1.7em;
    height: 1.7em;
    border-radius: 100%;
    text-align: center;
    vertical-align: middle;
    display: flex;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    color: white;
    font-size: 9px;
    font-weight: 900;
    margin-top: -2px;

    &__99-plus {
      width: 2.2em;
      height: 2.2em;
      background-color: #e11f56;
      margin-left: 10px;
      border-radius: 100%;
      text-align: center;
      vertical-align: middle;
      align-items: center;
      display: inline-flex;
      justify-content: center;
      color: white;
      font-size: 9px;
      font-weight: 900;
      margin-top: -2px;
    }
  }
}
</style>
